<p-terminal prompt="N.A.R.C :>" />